module.exports = __webpack_public_path__ + "img/6.fa402e49.jpg";